<div class="space-y-6">
  <!-- Address fixed recap -->
  <div
    class="p-4 rounded-2xl bg-gray-1 border border-gray-6 flex flex-col sm:flex-row sm:items-center justify-between gap-3"
  >
    <div class="flex items-start gap-3">
      <div
        class="p-2 rounded-xl bg-indigo-a3 text-indigo-11 shrink-0 flex items-center justify-center mt-0.5"
      >
        <mat-icon class="text-lg! w-5! h-5!">location_on</mat-icon>
      </div>
      <div>
        <div class="text-sm font-bold text-gray-12 flex items-center gap-2">
          <span>{{ model().address.label || model().address.street || 'Adresse enregistrée' }}</span>
          <span
            class="inline-flex items-center gap-1 text-[11px] font-semibold text-gray-11 bg-gray-3 border border-gray-6 px-2 py-0.5 rounded-full"
          >
            <mat-icon class="text-xs! w-3.5! h-3.5!">lock</mat-icon>
            Fixe
          </span>
        </div>
        <div class="text-xs text-gray-11 font-medium mt-0.5">
          {{ model().address.zipCode }} {{ model().address.city }}
          @if (model().address.region) {
            <span>({{ model().address.region }})</span>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Map preview with dynamic radius -->
  @if (model().coordinates.latitude && model().coordinates.longitude) {
    <div class="w-full h-64 md:h-72 rounded-2xl overflow-hidden bg-gray-2 border border-gray-6 shadow-xs">
      <aura-open-street-map
        [lat]="model().coordinates.latitude ?? 0"
        [lng]="model().coordinates.longitude ?? 0"
        [radius]="radius()"
      ></aura-open-street-map>
    </div>
  }

  <!-- Geolocation Type Selector Cards -->
  <div class="space-y-3">
    <div class="flex flex-col gap-1">
      <span class="text-sm font-bold text-gray-12">Zone à afficher sur l'annonce</span>
      <p class="text-xs text-gray-11">
        Choisissez le niveau de précision visible publiquement sur votre annonce. L'adresse exacte ne sera
        jamais divulguée.
      </p>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
      @for (option of displayOptions; track option.value) {
        <button
          type="button"
          (click)="setDisplayType(option.value)"
          class="p-4 rounded-xl border text-left transition-all cursor-pointer flex flex-col justify-between gap-2 select-none"
          [class]="
            model().geolocationType === option.value
              ? 'bg-indigo-a2 border-indigo-8 ring-2 ring-indigo-7/30 shadow-xs'
              : 'bg-gray-1 border-gray-6 hover:border-gray-8 hover:bg-gray-2/50'
          "
        >
          <div class="flex items-center justify-between w-full">
            <span
              class="text-sm font-bold"
              [class]="model().geolocationType === option.value ? 'text-indigo-12' : 'text-gray-12'"
            >
              {{ option.label }}
            </span>
            <mat-icon
              class="text-base! w-4! h-4!"
              [class]="model().geolocationType === option.value ? 'text-indigo-10' : 'text-gray-9'"
            >
              {{
                model().geolocationType === option.value ? 'radio_button_checked' : 'radio_button_unchecked'
              }}
            </mat-icon>
          </div>
          <p class="text-xs text-gray-11 leading-relaxed">
            {{ option.description }}
          </p>
        </button>
      }
    </div>
  </div>
</div>
